import { Skeleton } from "@capacit-com/lara-law-shared-ui";

interface SearchItemSkeletonProps {
  hasCategory?: boolean;
}

const SearchItemSkeleton = ({
  hasCategory = false,
}: SearchItemSkeletonProps) => {
  return (
    <div className="flex flex-col gap-2">
      {hasCategory && <Skeleton className="w-24 h-5 rounded-sm" />}
      {Array.from({ length: 20 }).map((_, index) => (
        <Skeleton key={index} className="w-full h-10 rounded-sm" />
      ))}
    </div>
  );
};

export default SearchItemSkeleton;
